import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { NuevoListadoEnvio } from '../connections/notificaciones/ListadoEnvioConnection';

interface Props {
    openDialog: boolean;
    handleCloseDialog: () => void;
}

type TipoBusquedaType = '' | 'Generar nuevo listado de envío' | 'Consultar listados de envío';

export const DialogNuevoListadoEnvio = ({ openDialog, handleCloseDialog }: Props) => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [tipoBusqueda, setTipoBusqueda] = useState<TipoBusquedaType>( '' );

    const handleGenerarListadoEnvio = async () => {

        setLoadingGuardar( true );

        if ( tipoBusqueda === 'Generar nuevo listado de envío' ) {

            await NuevoListadoEnvio().then( resp => {

                const { idListadoEnvio, success, message } = resp

                if (success) {

                    setTimeout(() => {

                        setLoadingGuardar(false);

                        navigate(`/listado-envio/generar/${idListadoEnvio}`);

                    }, 700);

                } else {

                    setTimeout(() => {

                        setLoadingGuardar(false);

                        dispatch(openSnackbar({ message: message, variant: 'error' }));

                    }, 700);
                }

            })

        }
        else if (tipoBusqueda === 'Consultar listados de envío') {

            setTimeout(() => {

                setLoadingGuardar(false);

                navigate('/listado-envio/consultar/');

            }, 700);

        }
    }

    const handleCerrarDialog = () => {

        setTipoBusqueda( '' );
        handleCloseDialog();

    }

    return (
        <>

            <Dialog
                fullWidth
                maxWidth='md'
                open={ openDialog }
            >

                <DialogTitle>Listado de envío</DialogTitle>

                <DialogContent>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Seleccione una opción:</FormLabel>
                                <RadioGroup row>

                                    <FormControlLabel
                                        label='Generar nuevo listado de envío'
                                        control={
                                            <Radio
                                                checked={ tipoBusqueda === 'Generar nuevo listado de envío' }
                                                onChange={ () => setTipoBusqueda( 'Generar nuevo listado de envío' ) }
                                            />
                                        }
                                    />

                                    <FormControlLabel
                                        label='Consultar listados de envío'
                                        control={
                                            <Radio
                                                checked={ tipoBusqueda === 'Consultar listados de envío' }
                                                onChange={ () => setTipoBusqueda( 'Consultar listados de envío' ) }
                                            />
                                        }
                                    />

                                </RadioGroup>

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>

                    <Button
                        variant="contained"
                        loading={ loadingGuardar }
                        disabled={ tipoBusqueda === '' }
                        onClick={ handleGenerarListadoEnvio }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    )
}